import { PlatformEntitlements } from 'lib/platform';
import type { Nullable } from 'utils/types';

import { MultiplatformSDKInstance } from '../sdk';
import { SDKFacade } from './_base';

export type EntitlementsInfo = {
  isPremium: boolean;
  hdWordsLeft: number;
  nextHdWordsGrant: number;
  nextHdWordsGrandDate?: Nullable<Date>;
  lastHdWordsGrantDate?: Nullable<Date>;
};

export class SDKSubscriptionFacade extends SDKFacade {
  private static _singleton: SDKSubscriptionFacade;

  constructor(sdk: MultiplatformSDKInstance) {
    super(sdk);
    SDKSubscriptionFacade._singleton = this;
  }

  static override get singleton(): SDKSubscriptionFacade {
    if (!SDKSubscriptionFacade._singleton) {
      throw new Error('SDKSubscriptionFacade is not initialized');
    }
    return SDKSubscriptionFacade._singleton;
  }

  public mapSDKEntitlementsToEntitlementsInfo = (entitlements: PlatformEntitlements | undefined): EntitlementsInfo => {
    if (!entitlements) {
      return {
        isPremium: false,
        hdWordsLeft: 0,
        nextHdWordsGrant: 0,
        nextHdWordsGrandDate: null,
        lastHdWordsGrantDate: null
      };
    }

    return {
      isPremium: entitlements.isPremium,
      hdWordsLeft: entitlements.hdWordsLeft,
      nextHdWordsGrant: entitlements.nextHdWordsGrant,
      nextHdWordsGrandDate: entitlements.nextHdWordsGrantDate ? new Date(entitlements.nextHdWordsGrantDate) : null,
      lastHdWordsGrantDate: entitlements.lastHdWordsGrantDate ? new Date(entitlements.lastHdWordsGrantDate) : null
    };
  };
}
